import { PillCheckbox } from '@/components/pill-checkbox';
import {
  VEHICLE_NAME_HATCHBACK,
  VEHICLE_NAME_HYBRID_CARS,
  VEHICLE_NAME_LUXURY_SEDAN,
  VEHICLE_NAME_MID_SIZED_SEDAN,
  VEHICLE_NAME_MPV,
  VEHICLE_NAME_SPORTS_CARS,
  VEHICLE_NAME_STATIONWAGON,
  VEHICLE_NAME_SUV,
} from '@/constants/global';

import styles from './styles.module.scss';
import type { Component } from './types';

export const CheckboxGroup: Component = ({
  name,
  checkboxOptions,
  allCheckbox,
  values,
  onAllCheckboxChange,
  onPartialCheckboxChange,
  onChange,
}) => {
  const handleAllCheckboxChange = ({ checked }: { checked?: boolean; }) => {
    const newValues = { ...values };

    for (const vehicleType in newValues) {
      if (Object.hasOwn(newValues, vehicleType)) {
        newValues[vehicleType].checked = checked;
      }
    }

    onAllCheckboxChange?.({
      name,
      type: 'checkbox',
      values: newValues,
    });
  };

  const handlePartialCheckboxChange = (
    names: string[],
  ) => ({ checked }: { checked?: boolean; }) => {
    const newValues = { ...values };

    for (const n of names) {
      newValues[n].checked = checked;
    }

    onPartialCheckboxChange?.({
      name,
      type: 'checkbox',
      values: newValues,
    });
  };

  const handleChange = ({
    name: checkboxName,
    value: checkboxValue,
    checked: isChecked,
  }: {
    name?: string;
    value?: string;
    checked?: boolean;
  }) => {
    if (checkboxName && checkboxValue) {
      onChange?.({
        name,
        type: 'checkbox',
        checkboxName,
        checkboxValue,
        isChecked,
      });
    }
  };

  return (
    <div className={styles.containerRoot}>
      {!!allCheckbox && (
        <div className={styles.containerCheckBox}>
          <PillCheckbox
            checked={Object.values(values).every(v => v.checked)}
            name={allCheckbox}
            value="all"
            onChange={handleAllCheckboxChange} />
        </div>
      )}
      <div className={styles.containerCheckBox}>
        <PillCheckbox
          checked={
            Object.values(values)
              .filter(v => v.name === VEHICLE_NAME_SUV
              || v.name === VEHICLE_NAME_MPV
              || v.name === VEHICLE_NAME_HYBRID_CARS
              || v.name === VEHICLE_NAME_LUXURY_SEDAN
              || v.name === VEHICLE_NAME_MID_SIZED_SEDAN
              || v.name === VEHICLE_NAME_SPORTS_CARS
              || v.name === VEHICLE_NAME_HATCHBACK
              || v.name === VEHICLE_NAME_STATIONWAGON)
              .every(v => v.checked)
          }
          name="All Passenger Cars"
          value="passenger-car"
          onChange={handlePartialCheckboxChange([
            VEHICLE_NAME_SUV,
            VEHICLE_NAME_MPV,
            VEHICLE_NAME_HYBRID_CARS,
            VEHICLE_NAME_LUXURY_SEDAN,
            VEHICLE_NAME_MID_SIZED_SEDAN,
            VEHICLE_NAME_SPORTS_CARS,
            VEHICLE_NAME_HATCHBACK,
            VEHICLE_NAME_STATIONWAGON,
          ])} />
      </div>
      {checkboxOptions.map(checkbox => (
        <div
          key={checkbox.name}
          className={styles.containerCheckBox}>
          <PillCheckbox
            checked={values[checkbox.name!].checked}
            name={checkbox.name}
            value={checkbox.value as string}
            onChange={handleChange} />
        </div>
      ))}
    </div>
  );
};
